export function shortenString(str, maxLength) {
    if (str.length > maxLength) {
        return str.slice(0, maxLength) + ' ...';
    } else {
        return str;
    }
}